module.exports = __webpack_public_path__ + "img/small-3-mob.99261214.jpg";